export const linkListTranslation = {
  addLink: 'linklist-add-link',
  save: 'linklist-save',
  cancel: 'linklist-cancel',
  delete: 'linklist-delete',
  isPrivate: 'linklist-is-private',
}
